<div class="accordion" *ngIf="dataSource">
  <div class="accordion__holder" (click)="onClick.emit()">
    <p>{{ dataSource?.title }}</p>
    <app-action-menu
      topPosition="13px"
      [isOpen]="isMenuOpen"
      (delete)="onDelete.emit()"
      (edit)="onEdit.emit()"
      (outsideClick)="closeAllMenu.emit()"
      (open)="openMenu.emit()"
    ></app-action-menu>
  </div>
  <article [style]="'max-height:' + maxHeight" [id]="name">
    <div [innerHtml]="santizedContent"></div>
  </article>
</div>
